import React, { useState, useEffect } from "react";
import { HiColorSwatch } from "react-icons/hi";
import { MdOutlineBluetoothDisabled } from "react-icons/md";
import { Offcanvas } from "react-bootstrap";
const DeviceSettingsSidebar = ({ isOpen, onClose, device }) => {
  const [activeTab, setActiveTab] = useState("channels");
  const [selectedLocation, setSelectedLocation] = useState("");
  const [linkedLocations, setLinkedLocations] = useState([]);
  const [channels, setChannels] = useState([
    {
      name: "Channel Name",
      type: ["Discrete", "Sense", "Control"],
      isInverted: true,
      isAuxiliary: true,
      color: "#FF5733",
      selectedType: "Discrete",
    },
    {
      name: "Channel Name",
      type: ["Proportional", "Actuate", "Control"],
      isInverted: false,
      isAuxiliary: true,
      color: "#33FF57",
      selectedType: "Proportional",
    },
    {
      name: "Channel Name",
      type: ["Discrete", "Actuate", "Status"],
      isInverted: false,
      isAuxiliary: true,
      color: "#3357FF",
      selectedType: "Discrete",
    },
    {
      name: "Channel Name",
      type: ["Proportional", "Sense", "Status"],
      isInverted: true,
      isAuxiliary: false,
      color: "#FF33F5",
      selectedType: "Proportional",
    },
  ]);
  const availableLocations = [
    "Mumbai",
    "Delhi",
    "Bangalore",
    "Hyderabad",
    "Chennai",
    "Kolkata",
    "Pune",
    "Ahmedabad",
    "Jaipur",
    "Surat",
  ];
  useEffect(() => {
    if (device?.location?.locationOption) {
      setLinkedLocations(device?.location?.locationOption);
    }
  }, [device]);

  useEffect(() => {
    const locationObj = device?.device?.runtime?.attributes?.location;
    if (locationObj?.latitude && locationObj?.longitude) {
      const { latitude, longitude } = locationObj;
      fetch(
        `https://nominatim.openstreetmap.org/reverse?lat=${latitude}&lon=${longitude}&format=json`
      )
        .then((res) => res.json())
        .then((data) => {
          const place = data?.display_name || "Unknown location";
          setLinkedLocations([place]);
        })
        .catch((err) => console.error("Location fetch failed", err));
    }

    const paramData = device?.parameters;
    if (paramData) {
      const channelData = Object.entries(paramData).map(([key, val]) => ({
        name: key,
        type: ["Discrete", "Sense", "Control"],
        selectedType: "Type A",
        color: `#${val.color}`,
        isInverted: val.inverted,
        isAuxiliary: val.auxillary,
      }));
      setChannels(channelData);
    }
  }, [device]);

  const handleToggle = (index, field) => {
    const updatedChannels = [...channels];
    updatedChannels[index][field] = !updatedChannels[index][field];
    setChannels(updatedChannels);
  };
  const handleNameChange = (index, value) => {
    const updatedChannels = [...channels];
    updatedChannels[index].name = value;
    setChannels(updatedChannels);
  };
  const handleColorChange = (index, value) => {
    const updatedChannels = [...channels];
    updatedChannels[index].color = value;
    setChannels(updatedChannels);
  };
  const handleTypeChange = (index, value) => {
    const updatedChannels = [...channels];
    updatedChannels[index].selectedType = value;
    setChannels(updatedChannels);
  };
  const handleAddLocation = () => {
    if (selectedLocation && !linkedLocations.includes(selectedLocation)) {
      setLinkedLocations([...linkedLocations, selectedLocation]);
      setSelectedLocation("");
    }
  };
  const handleRemoveLocation = (locationToRemove) => {
    setLinkedLocations(
      linkedLocations.filter((location) => location !== locationToRemove)
    );
  };
  if (!isOpen) return null;
  return (
    <Offcanvas
      show={isOpen}
      onHide={onClose}
      placement="end"
      backdrop={true}
      style={{
        "--bs-offcanvas-width": "unset",
        width: "480px",
        "--bs-offcanvas-height": "unset",
        height: "100%",
      }}
    >
      <Offcanvas.Header closeButton>
        <Offcanvas.Title>
          <h2 className="tw-text-lg tw-font-semibold">
            {device.id}
          </h2>
          <div className="tw-text-sm tw-text-gray-500"><strong>{device.device.model}<br/> {device.device.firmware_version}</strong></div>
        </Offcanvas.Title>
      </Offcanvas.Header>
      <Offcanvas.Body>
        <div className="tw-h-[calc(93vh-56px)] tw-flex tw-flex-col">
          <div className="tw-flex tw-border-b">
            <button
              className={`tw-px-6 tw-py-3 tw-text-sm ${
                activeTab === "channels"
                  ? "tw-border-b-2 tw-border-blue-500 tw-text-blue-500"
                  : "tw-text-gray-500"
              }`}
              onClick={() => setActiveTab("channels")}
            >
              Channels
            </button>
            <button
              className={`tw-px-6 tw-py-3 tw-text-sm ${
                activeTab === "locations"
                  ? "tw-border-b-2 tw-border-blue-500 tw-text-blue-500"
                  : "tw-text-gray-500"
              }`}
              onClick={() => setActiveTab("locations")}
            >
              Locations
            </button>
          </div>
          {/* Content Area */}
          <div className="tw-flex-1 tw-overflow-y-auto">
            {activeTab === "channels" && (
              <div className="tw-p-4">
                <p className="tw-text-sm tw-text-gray-500 tw-mb-4">
                  If you wish to change the channel properties, use the channel options below <br/><strong>Discrete/Sense/Control</strong>
                </p>
                {channels.map((channel, index) => (
                  <div key={index} className="tw-mb-8">
                    <div className="tw-flex tw-gap-2 tw-mb-3">
                      <div className="tw-flex-1">
                        <input
                          type="text"
                          value={channel.name}
                          disabled
                          onChange={(e) =>
                            handleNameChange(index, e.target.value)
                          }
                          className="tw-w-full tw-px-3 tw-py-2 tw-border tw-rounded tw-text-sm"
                          placeholder="Enter channel name"
                        />
                      </div>
                      <div className="tw-relative tw-flex tw-items-center">
                        <HiColorSwatch className="tw-absolute tw-left-3 tw-text-gray-400" />
                        <input
                          type="color"
                          value={channel.color}
                          onChange={(e) =>
                            handleColorChange(index, e.target.value)
                          }
                          className="tw-w-10 tw-h-8 tw-opacity-50"
                        />
                      </div>
                    </div>
                    <div className="tw-flex tw-justify-between tw-items-center">
                      <div className="tw-flex tw-gap-2">
                        {channel.type.map((type, typeIndex) => (
                          <button
                            key={typeIndex}
                            className="tw-px-3 tw-py-1 tw-text-xs tw-bg-blue-50 tw-text-blue-600 tw-rounded hover:tw-bg-blue-100"
                          >
                            {type}
                          </button>
                        ))}
                      </div>
                      <div className="tw-flex tw-justify-between tw-items-center tw-mb-2">
                        <div className="tw-flex tw-items-center tw-gap-4">
                          <div className="tw-flex tw-items-center tw-gap-1">
                            <span className="tw-text-xs tw-text-gray-500">
                              Inverted
                            </span>
                            <button
                              disabled
                              onClick={() => handleToggle(index, "isInverted")}
                              className={`tw-w-8 tw-h-4 tw-rounded-full tw-relative ${
                                channel.isInverted
                                  ? "tw-bg-green-500"
                                  : "tw-bg-gray-300"
                              }`}
                            >
                              <span
                                className={`tw-absolute tw-w-3 tw-h-3 tw-rounded-full tw-bg-white tw-top-0.5 tw-transition-transform ${
                                  channel.isInverted
                                    ? "tw-right-0.5"
                                    : "tw-left-0.5"
                                }`}
                              />
                            </button>
                          </div>
                          <div className="tw-flex tw-items-center tw-gap-1">
                            <span className="tw-text-xs tw-text-gray-500">
                              Auxiliary
                            </span>
                            <button
                              disabled
                              onClick={() => handleToggle(index, "isAuxiliary")}
                              className={`tw-w-8 tw-h-4 tw-rounded-full tw-relative ${
                                channel.isAuxiliary
                                  ? "tw-bg-green-500"
                                  : "tw-bg-gray-300"
                              }`}
                            >
                              <span
                                className={`tw-absolute tw-w-3 tw-h-3 tw-rounded-full tw-bg-white tw-top-0.5 tw-transition-transform ${
                                  channel.isAuxiliary
                                    ? "tw-right-0.5"
                                    : "tw-left-0.5"
                                }`}
                              />
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            )}
            {activeTab === "locations" && (
              <div className="tw-p-4">
                <div className="tw-mb-6">
                  <label className="tw-block tw-mb-2">
                    <span className="tw-text-sm tw-font-medium">Locations</span>
                    <span className="tw-text-red-500">*</span>
                  </label>
                  <div className="tw-flex tw-gap-2">
                    <select
                      value={selectedLocation}
                      onChange={(e) => setSelectedLocation(e.target.value)}
                      className="tw-flex-1 tw-form-select tw-block tw-w-full tw-rounded-md tw-border tw-border-gray-300 tw-px-3 tw-py-2"
                    >
                      <option value="">Select location</option>
                      {availableLocations.map((location) => (
                        <option key={location} value={location}>
                          {location}
                        </option>
                      ))}
                    </select>
                    <button
                      onClick={handleAddLocation}
                      disabled={!selectedLocation}
                      className="tw-px-4 tw-py-2 tw-text-sm tw-text-white tw-bg-blue-500 hover:tw-bg-blue-600 tw-rounded disabled:tw-opacity-50"
                    >
                      Add
                    </button>
                  </div>
                </div>
                <div>
                  <h3 className="tw-text-sm tw-font-medium tw-mb-3">
                    Linked Locations
                  </h3>
                  <div className="tw-space-y-2">
                    {linkedLocations.map((location, index) => (
                      <div
                        key={index}
                        className="tw-flex tw-justify-between tw-items-center tw-p-3 tw-border tw-rounded-md"
                      >
                        <span className="tw-text-sm">{location}</span>
                        <button
                          onClick={() => handleRemoveLocation(location)}
                          className="tw-text-gray-400 hover:tw-text-red-500"
                        >
                          <MdOutlineBluetoothDisabled className="tw-w-5 tw-h-5" />
                        </button>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            )}
          </div>
          <div className="tw-p-4 tw-border-t tw-flex tw-justify-end tw-gap-3">
            <button
              onClick={onClose}
              className="tw-px-4 tw-py-2 tw-text-sm tw-text-gray-600 hover:tw-bg-gray-100 tw-rounded"
            >
              Discard
            </button>
            <button className="tw-px-4 tw-py-2 tw-text-sm tw-text-white tw-bg-blue-500 hover:tw-bg-blue-600 tw-rounded">
              Save & Update
            </button>
          </div>
        </div>
      </Offcanvas.Body>
    </Offcanvas>
  );
};
export default DeviceSettingsSidebar;
